module.exports = __webpack_public_path__ + "img/dashboard-splash.199ccfb6.png";